import createCollectionResource from 'src/actions/shared/createResource';
import { updateTopicsWithHierarchies } from 'src/actions/topics/topicsResource';

export class TopicAncestry {
  id: string;
  topicId: string;
  ancestralTopicId: string;
  isParent: boolean;
}

const topicsHierarchyResource = createCollectionResource<TopicAncestry>({
  name: 'topicsHierarchy',
  endpoint: 'v1/orgs/:orgId/topic-hierarchy/:topicHierarchyId',
  observerCreator: ({ actions }) => {
    return ({ dispatch, getState }) => {
      return {
        onBroadcast(item) {
          dispatch(actions.broadcast(item));
          updateTopicsWithHierarchies(dispatch, getState);
        },
        onBroadcastDelete(_: any, { topicHierarchyId }) {
          dispatch(actions.broadcastDelete(topicHierarchyId));
          updateTopicsWithHierarchies(dispatch, getState);
        },
      };
    };
  },
});

export default topicsHierarchyResource;
